import { render } from "./MessagesGroupId.vue?vue&type=template&id=3f5c60cb&scoped=true&ts=true"
import script from "./MessagesGroupId.vue?vue&type=script&lang=ts"
export * from "./MessagesGroupId.vue?vue&type=script&lang=ts"

import "./MessagesGroupId.vue?vue&type=style&index=0&id=3f5c60cb&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f5c60cb"]])

export default __exports__